import { render, staticRenderFns } from "./star.svg.vue?vue&type=template&id=7a2fb9a8&"
import script from "./star.svg.vue?vue&type=script&lang=js&"
export * from "./star.svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports